import { render, staticRenderFns } from "./FormText.vue?vue&type=template&id=c267b48a&scoped=true"
import script from "./FormText.vue?vue&type=script&lang=js"
export * from "./FormText.vue?vue&type=script&lang=js"
import style0 from "./FormText.vue?vue&type=style&index=0&id=c267b48a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c267b48a",
  null
  
)

export default component.exports